<template>
  <section class="wagb-home__hero">
    <div class="wagb-home__hero-card">
      <div class="wagb-home__hero-card-bg" aria-hidden="true">
        <span class="blob blob--tr" />
        <span class="blob blob--bl" />
        <span class="dots dots--left" />
        <span class="dots dots--right" />
      </div>

      <div class="wagb-home__hero-card-inner">
        <img
          class="wagb-home__hero-card-logo"
          :src="hero.logo"
          :alt="hero.h1"
          width="96"
          height="96"
        />

        <h1 class="wagb-home__hero-card-title">{{ hero.h1 }}</h1>
        <p class="wagb-home__hero-subtitle">{{ hero.subtitle }}</p>
        <p class="wagb-home__hero-card-desc">{{ hero.description }}</p>

        <router-link :to="hero.ctaLink" class="wagb-home__hero-card-btn">
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path
              fill="currentColor"
              d="M12 3a1 1 0 0 1 1 1v9.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V4a1 1 0 0 1 1-1z"
            />
            <path fill="currentColor" d="M4 18a1 1 0 0 1 1-1h14a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1z" />
          </svg>
          {{ hero.cta }}
        </router-link>

        <div class="wagb-home__hero-stats">
          <div v-for="stat in hero.card.stats" :key="stat.label" class="wagb-home__hero-stat">
            <span class="wagb-home__hero-stat-icon" v-html="stat.icon" />
            <span class="wagb-home__hero-stat-copy">
              <span class="wagb-home__hero-stat-label">{{ stat.label }}</span>
              <strong class="wagb-home__hero-stat-value">{{ stat.value }}</strong>
            </span>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeHero',
  props: {
    hero: {
      type: Object,
      required: true,
    },
  },
};
</script>
